export enum ExtraInterestProperties {
    BRIDGING_LOAN_FIXED = 'overbruggingskrediet',
    BRIDGING_LOAN_VARIABLE = 'overbruggingskredietVariabel',
    CREDIT_LOAN_FIXED = 'krediethypotheek',
    CREDIT_LOAN_VARIABLE = 'krediethypotheekVariabel',
}

export enum ExtraInterestTypes {
    FIXED = 'vast',
    VARIABLE = 'variabel',
}
